import { RootState } from '@/store/store';
import { createWidgetTypes } from '@/store/types/createWidgetTypes';
import { createSelector } from '@reduxjs/toolkit';

export const selectWidget = (state: RootState): createWidgetTypes => state.createWidget.data;

export const selectIsWidgetExisting = createSelector(
	[selectWidget],
	(widgetState) => widgetState.isExisting
);
